import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40fd382e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-pages-favorites" }
const _hoisted_2 = { class: "my-pages-favorites__header-container" }
const _hoisted_3 = { class: "my-pages-favorites__header" }
const _hoisted_4 = { class: "my-pages-favorites__description" }
const _hoisted_5 = { class: "my-pages-favorites__main-container" }
const _hoisted_6 = { class: "row g-5 g-md-4 product-listings" }

import TressNavigationPills from "@/components/TressNavigationPills.vue";
import TressProductListings from "@/components/TressProductListings.vue";
import { PropType } from "vue";
import { ILiveLink } from "@/models/ILiveLink";
import { IIndexTile } from "@/models/IIndexTile";
import { CustomerType } from "@/enums/CustomerType";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressTheMyPagesFavorites',
  props: {
  links: {
    type: Array as PropType<Array<ILiveLink>>,
    required: true,
  },
  products: {
    type: Array as PropType<Array<IIndexTile>>,
    required: true,
  },
  header: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
},
  setup(__props) {


const showAsB2b = window.customerType === CustomerType.Business;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(__props.header), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(__props.description), 1),
      _createVNode(TressNavigationPills, { links: __props.links }, null, 8, ["links"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(TressProductListings, {
          content: __props.products,
          "show-as-b2b": showAsB2b,
          class: "my-pages-favorites__product-listings"
        }, null, 8, ["content"])
      ])
    ])
  ]))
}
}

})